import { CustomerRole } from '@browsing/config';
import { PlusStatus } from '@browsing/plus';

export interface MyFilter {}

export interface State {
    errors: any[];
    myFilter: MyFilter;
    currency: any;
    email?: string;
    firstName?: string;
    lastName?: string;
    eventSecrets?: any;
    gender?: string;
    isFetching: boolean;
    isInitialized: boolean;
    isLoggedIn?: boolean;
    hashedCustomerNumber?: string;
    countryOfResidence?: any;
    nwlSubscription?: any;
    countedCustomerOrders?: number;
    emailProvider?: string;
    myFilterLoading?: boolean;
    preferredCountry?: string;
    customerNumber?: string;
    mailConfirmed?: boolean;

    role?: CustomerRole;

    plus?: PlusStatus;

    acr?: string;
    areCredentialsCompromised?: boolean;
}

// TODO: check if we need this reducer at all
// the customer initial state is always being initialized on server-side (server/routes/react.js)
export const initialState: State = {
    isFetching: false,
    isInitialized: false,
    // TODO Think of making myFilter { MALE: { }, FEMALE: { } } by default
    // TODO add gender, eventSecrets defaults
    errors: [],
    myFilter: {},
    currency: null,
};
